import { PropTypes } from 'prop-types';
import classNames from 'classnames';

const ListItem = ({ text, value, selected, onClick }) => {
  const classes = classNames({
    'list-item': true,
    'list-item--selected': !!selected,
  });

  return (
    <li key={`item-${value}`} className={classes}>
      <a onClick={() => onClick(value)}>{text}</a>
    </li>
  );
};

ListItem.propTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

ListItem.defaultProps = {
  selected: false,
  onClick: () => {},
};

export default ListItem;
